export default __webpack_public_path__ + "ff815ef7b3a7d177b2204ef93ab863d6.svg";